
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import Vue from "vue";
import { AWSFile } from "../../models/aws-file";
import { AWSFileService } from "../../services/aws-file-service";

export default Vue.extend({
	data() {
		return {
			allImages: [] as AWSFile[],
			sending: false,
		};
	},
	computed: {
		allowedExtensions():string[] {
			return ["jpg", "png", "jpeg"];
		},
	},
	methods: {
		async getAllImages() {
			this.allImages = await AWSFileService.listFiles("/print-layouts");
		},
		async onFileInput(file: File) {
			this.sending = true;
			await AWSFileService.uploadFile("/print-layouts", file);
			this.getAllImages();
			this.sending = false;
		},
		async removeImg(awsFile: AWSFile) {
			await AWSFileService.deleteFiles([awsFile]);
			this.getAllImages();
		},
		encodeURI(uri:string):string {
			return encodeURI(uri);
		},
		useImage(img:AWSFile){
			this.$emit("img", img);
			this.close();
		},
		close(){
			this.$emit("close");
		}
	},
	async created() {
		this.getAllImages();
	},
	components: {
		AppFileUpload,
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
